import { makeStyles } from "@mui/styles";
import theme from "src/theme";
import { MAX_XL_TABLET } from "src/pages/game-new2/constants";

export const useStyles = makeStyles({
    container: {
        width: "100%",
        height: "100%",
        // maxHeight: 888,
        maxHeight: "100%",
        display: "grid",
        gridTemplateColumns: "0.61fr 0.39fr",
        gridColumnGap: 0,
        "&.isMobile": {
            [theme.breakpoints.down(MAX_XL_TABLET)]: {
                maxHeight: "100%",
                display: "grid",
                gridTemplateColumns: "1fr",
                justifyItems: "center",
            },
        },

        "&.isFreePlay": {
            display: "block",
        },
    },

    rightBlockWrapper: {
        width: "100%",
        borderRadius: 24,
        background: "rgba(245, 245, 245, 0.05)",
        display: "grid",
        gridTemplateRows: "auto 1fr",
        padding: 12,
        overflow: "hidden",
        "&.isMobile": {
            [theme.breakpoints.down(MAX_XL_TABLET)]: {
                display: "none",
            },
        },
        "&.isView": {
            gridTemplateRows: "1fr",
            position: "relative",
            background: "none",
        },
    },
    previewFullScreenBox: {
        // "@media (orientation: landscape)": {
        //     height: "calc(100dvh - 120px)",
        //     width: "auto",
        // },
        // "@media (orientation: portrait)": {
        //     height: "auto",
        //     width: "90dvw",
        // },
        width: "90%",
        maxWidth: "1920px",
        height: "calc(100dvh - 150px)",
        maxHeight: "50dvw",
        borderRadius: "12px",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        opacity: 1,
        overflow: "hidden",
        position: "absolute",
        background: "#121212",
        transformOrigin: "top right",
        transform: "scale(0)",
        margin: "0px",
        // borderBottomLeftRadius: "100dvw",
        // borderBottomRightRadius: "100dvw",
        transition: "transform 0.3s, opacity 0.3s ease-in-out",

        "&.isOpen": {
            transform: "scale(1)",
            opacity: 1,

            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
            borderTopLeftRadius: "0px",
            zIndex: 999,
            // "@media (orientation: landscape)": {
            //     height: "calc(100dvh - 120px)",
            //     width: "auto",
            // },
            // "@media (orientation: portrait)": {
            //     height: "auto",
            //     width: "90dvw",
            // },
        },
        "&.hidden": {
            "@media (orientation: landscape)": {
                transform: "scale(0)",
                opacity: 1,
                // borderBottomLeftRadius: "100dvw",
                // borderBottomRightRadius: "100dvw",
                // borderTopLeftRadius: "100dvw",
                transition: "transform 0.3s, opacity 0.3s ease-in-out",
            },
        },
    },
});
